import { type PropsWithChildren } from "react";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type WithClassName<T = unknown> = T & {
  className?: string;
};

export type WithClassNameAndChildren<T = unknown> = PropsWithChildren<
  WithClassName<T>
>;
